export { addNextjsError, onRouterTransitionStart } from "@datadog/browser-rum-nextjs";
